module.exports = require('./helpers/bundle-url').getBundleURL('13ph5') + "logo-light.c71fdb70.svg";